
/* ============================================================================
   COMPORTAMIENTO
   Todo vainilla, sin librerías. Cada bloque va comentado y es independiente:
   se puede borrar uno sin romper los demás.
   ========================================================================== */
(function(){
  'use strict';
  const $  = (s,c)=>(c||document).querySelector(s);
  const $$ = (s,c)=>[...(c||document).querySelectorAll(s)];

  /* --- 0 · cuenta atrás de la oferta ---------------------------------------
     Arranca en 49:13 y pinta a la vez TODOS los elementos con .js-cuenta: hoy
     son tres, el de la barra de arriba, el selector y el sticky, y por
     construcción no pueden desincronizarse.
     Se guarda el instante en que termina, no los segundos que quedan, para que
     recargar no lo reinicie: un reloj que vuelve a 49:13 en cada F5 deja de
     creérselo cualquiera. Al agotarse abre otra ventana, porque quedarse
     clavado en 00:00 con la oferta todavía puesta parece que está roto. */
  const relojes = $$('.js-cuenta');
  if (relojes.length){
    const SEG = 2953;                      // 49:13
    const MS = () => SEG * 1000;
    // La duración va dentro de la llave: si se cambia el número de arriba, lo
    // guardado deja de valer solo y el reloj arranca de nuevo para todos, sin
    // tener que vaciar nada a mano.
    const LLAVE = 'viba:oferta-hasta:' + SEG;
    const leer = () => { try { return +localStorage.getItem(LLAVE) || 0 } catch(e){ return 0 } };
    const guardar = v => { try { localStorage.setItem(LLAVE, v) } catch(e){} };
    let fin = leer();
    if (!fin || fin <= Date.now()) { fin = Date.now() + MS(); guardar(fin); }
    const pintar = () => {
      let seg = Math.round((fin - Date.now()) / 1000);
      if (seg <= 0) { fin = Date.now() + MS(); guardar(fin); seg = Math.round((fin - Date.now()) / 1000); }
      const txt = String(Math.floor(seg / 60)).padStart(2, '0') + ':' +
                  String(seg % 60).padStart(2, '0');
      relojes.forEach(r => r.textContent = txt);
    };
    pintar();
    setInterval(pintar, 1000);
  }

  /* --- 0b · «Ver oferta» deja el pack elegido en el centro de la pantalla ---
     No basta con saltar al selector: lo que tiene que quedar a la vista es la
     tarjeta marcada (hoy la de 2+1), con la de 1 mes encima y la de 3+2 debajo.
     Se busca .bpack.on en el momento del clic, así que si el visitante ya ha
     cambiado de pack, centra el suyo y no el de por defecto. */
  const verOferta = $('#verOferta');
  if (verOferta) verOferta.addEventListener('click', ev => {
    const elegido = $('.bpack.on') || $('#bundle');
    if (!elegido) return;
    ev.preventDefault();
    const quieto = matchMedia('(prefers-reduced-motion:reduce)').matches;
    elegido.scrollIntoView({ block:'center', behavior: quieto ? 'auto' : 'smooth' });
  });

  /* --- 0c · fecha de entrega -----------------------------------------------
     Una sola fecha: el día laborable siguiente. Sábados y domingos no cuentan,
     porque la mensajería no reparte: quien entre el viernes ve el lunes. */
  const cajaEntrega = $('#entrega span');
  if (cajaEntrega){
    const DIA = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
    const MES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto',
                 'septiembre','octubre','noviembre','diciembre'];
    const esLaborable = d => d.getDay() !== 0 && d.getDay() !== 6;
    const masLaborables = (desde, n) => {
      const d = new Date(desde);
      while (n > 0){ d.setDate(d.getDate() + 1); if (esLaborable(d)) n--; }
      return d;
    };
    // El día siguiente: 24 h clavadas. Decisión de Joan el 15/09.
    const llega = masLaborables(new Date(), 1);
    cajaEntrega.innerHTML = 'Tu pedido te llegará a casa el <b>' +
      DIA[llega.getDay()] + ', ' + llega.getDate() + ' de ' + MES[llega.getMonth()] + '</b>';
  }

  /* --- 1 · marquesina ------------------------------------------------------
     Son solo dos mensajes, así que primero se repiten hasta cubrir de sobra el
     ancho de la pantalla y después se duplica el conjunto entero: la animación
     desplaza justo la mitad, y así el bucle no tiene costura en ningún tamaño. */
  const mq = $('#marquee');
  if (mq){
    const base = mq.innerHTML;
    let vueltas = 0;
    while (mq.scrollWidth < innerWidth * 1.6 && vueltas++ < 24) mq.innerHTML += base;
    mq.innerHTML += mq.innerHTML;
  }

  /* --- 2 · galería: miniaturas, flechas y gesto de deslizamiento ----------- */
  const stage = $('#stage');
  if (stage){
    const slides = $$('img', stage);
    const thumbs = $('#thumbs');
    let i = 0;

    /* una miniatura de 58 px no necesita la imagen entera. Las nuestras traen
       su versión «-mini» de 140 px, hecha por preparar.py; las que todavía son
       del CDN de la referencia se piden pequeñas con ?width=                   */
    const mini = u => u.includes('/imagenes/web/galeria/')
      ? u.replace(/\.webp$/, '-mini.webp')
      : (u.includes('?') ? u+'&width=140' : u+'?width=140');
    const fuente = im => im.getAttribute('src') || im.dataset.src;

    slides.forEach((im, n)=>{
      const b = document.createElement('button');
      b.className = n===0 ? 'on' : '';
      b.setAttribute('aria-label','Imagen '+(n+1));
      b.innerHTML = '<img loading="lazy" decoding="async" src="'+mini(fuente(im))+'" alt="">';
      b.onclick = ()=> go(n);
      thumbs.appendChild(b);
    });

    /* una diapositiva solo se descarga cuando hace falta.
       ⚠️ 16/09: antes solo ponía el src. Como la foto se ve a 526 px y en una
       pantalla retina eso son 1052 px de verdad, el navegador estiraba la de
       700 px y se veía blanda. Ahora las nuestras piden también la @2x.        */
    function cargar(n, prioridad){
      const im = slides[n];
      if (!im || !im.dataset.src) return;
      /* 21/09 · orden de importancia: las que se traen de fondo van marcadas
         como poco urgentes, para que nunca le quiten el sitio a la foto que el
         lector está mirando ahora mismo.                                      */
      if (prioridad) im.fetchPriority = prioridad;
      const u = im.dataset.src;
      const medidas = '(max-width:900px) 92vw, 573px';
      /* 21/09: cada diapositiva va dentro de un <picture> con su versión AVIF,
         que pesa la mitad. Se rellena ANTES que el <img>, porque el navegador
         elige en cuanto la imagen tiene src y ya no vuelve a mirar.           */
      const fuenteAvif = im.parentElement && im.parentElement.querySelector
        ? im.parentElement.querySelector('source[type="image/avif"][data-src]') : null;
      if (fuenteAvif){
        const a = fuenteAvif.dataset.src;
        fuenteAvif.srcset = a + ' 700w, ' + a.replace(/\.avif$/, '@2x.avif') + ' 1254w';
        fuenteAvif.sizes  = medidas;
        delete fuenteAvif.dataset.src;
      }
      if (u.includes('/imagenes/web/galeria/')){
        im.srcset = u + ' 700w, ' + u.replace(/\.webp$/, '@2x.webp') + ' 1254w';
        im.sizes  = medidas;
      }
      im.src = u;
      delete im.dataset.src;
    }
    /* y cuando el navegador está ocioso se adelanta a traer el resto: así el
       usuario nunca espera, pero no se estorba la primera pintada             */
    const ocioso = window.requestIdleCallback || (f=>setTimeout(f,1800));
    addEventListener('load', ()=> ocioso(()=> slides.forEach((_,n)=>cargar(n, 'low'))));

    let animando = false;
    let pendiente = null;
    function go(n){
      if (animando){ pendiente = n; return; }
      const destino = (n + slides.length) % slides.length;
      if (destino === i) return;
      const haciaDerecha = n > i;
      const sale = slides[i];
      const entra = slides[destino];
      cargar(destino); cargar((destino + 1) % slides.length);

      /* Se coloca la siguiente foto fuera del marco sin animarla; luego ambas
         se desplazan a la vez en el sentido de la navegación. */
      entra.style.transition = 'none';
      entra.classList.remove('on', 'gal-left', 'gal-right');
      entra.classList.add(haciaDerecha ? 'gal-right' : 'gal-left');
      void entra.offsetWidth;
      entra.style.transition = '';
      sale.classList.remove('on', 'gal-left', 'gal-right');
      sale.classList.add(haciaDerecha ? 'gal-left' : 'gal-right');
      entra.classList.remove('gal-left', 'gal-right');
      entra.classList.add('on');

      i = destino;
      $$('button', thumbs).forEach((b,k)=> b.classList.toggle('on', k===i));
      const act = $$('button', thumbs)[i];
      if (act) act.scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'});

      if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      animando = true;
      let terminado = false;
      const terminar = ()=>{
        if (terminado) return;
        terminado = true;
        entra.removeEventListener('transitionend', alTerminar);
        animando = false;
        if (pendiente !== null){
          const siguiente = pendiente;
          pendiente = null;
          go(siguiente);
        }
      };
      const alTerminar = e=>{ if (e.target === entra && e.propertyName === 'transform') terminar(); };
      entra.addEventListener('transitionend', alTerminar);
      setTimeout(terminar, 550);
    }
    $('#galPrev').onclick = ()=> go(i-1);
    $('#galNext').onclick = ()=> go(i+1);

    /* arrastrar sobre la imagen para cambiar (móvil) */
    let x0=null;
    stage.addEventListener('touchstart', e=>{ x0 = e.touches[0].clientX; }, {passive:true});
    stage.addEventListener('touchend', e=>{
      if (x0===null) return;
      const d = e.changedTouches[0].clientX - x0;
      if (Math.abs(d) > 44) go(d<0 ? i+1 : i-1);
      x0 = null;
    }, {passive:true});
  }

  /* --- 2b · composición del producto: cajón lateral -----------------------
     El contenido ya está en el HTML: abrirlo no hace ninguna petición nueva. */
  const compBotones = Array.from(document.querySelectorAll('[aria-controls="compPanel"]'));
  const compShell = $('#compShell');
  const compClose = $('#compClose');
  const compBackdrop = $('#compBackdrop');
  if (compBotones.length && compShell && compClose && compBackdrop){
    let focoAnterior = compBotones[0];
    let ocultarTimer;
    const abrirComposicion = ()=>{
      clearTimeout(ocultarTimer);
      focoAnterior = document.activeElement;
      compShell.hidden = false;
      document.body.classList.add('comp-lock');
      compBotones.forEach(b=>b.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(()=>{
        compShell.classList.add('is-open');
        compClose.focus({preventScroll:true});
      });
    };
    const cerrarComposicion = ()=>{
      compShell.classList.remove('is-open');
      document.body.classList.remove('comp-lock');
      compBotones.forEach(b=>b.setAttribute('aria-expanded', 'false'));
      clearTimeout(ocultarTimer);
      ocultarTimer = setTimeout(()=>{
        if (!compShell.classList.contains('is-open')) compShell.hidden = true;
      }, matchMedia('(prefers-reduced-motion:reduce)').matches ? 0 : 400);
      if (focoAnterior && focoAnterior.focus) focoAnterior.focus({preventScroll:true});
    };
    compBotones.forEach(b=>b.addEventListener('click', abrirComposicion));
    compClose.addEventListener('click', cerrarComposicion);
    compBackdrop.addEventListener('click', cerrarComposicion);
    document.addEventListener('keydown', e=>{
      if (compShell.hidden || !compShell.classList.contains('is-open')) return;
      if (e.key === 'Escape'){
        e.preventDefault();
        cerrarComposicion();
      } else if (e.key === 'Tab'){
        e.preventDefault();
        compClose.focus();
      }
    });
  }

  /* --- 3 · carruseles: arrastre con ratón, flechas y puntos --------------- */
  $$('[data-rail]').forEach(rail=>{
    let down=false, startX=0, startL=0, moved=0;

    rail.addEventListener('pointerdown', e=>{
      if (e.pointerType === 'touch') return;      /* el táctil ya desliza solo */
      down=true; moved=0; startX=e.clientX; startL=rail.scrollLeft;
      rail.classList.add('drag');
    });
    rail.addEventListener('pointermove', e=>{
      if(!down) return;
      const d = e.clientX - startX;
      moved = Math.abs(d);
      rail.scrollLeft = startL - d;
    });
    const end = ()=>{ if(!down) return; down=false; rail.classList.remove('drag'); };
    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointerleave', end);
    /* un arrastre no debe abrir el enlace que hay debajo */
    rail.addEventListener('click', e=>{ if(moved>6){ e.preventDefault(); e.stopPropagation(); } }, true);

    /* flechas del pie del carrusel, si las tiene */
    const foot = rail.nextElementSibling;
    if (foot && foot.classList.contains('carou__ft')){
      const step = ()=> (rail.firstElementChild ? rail.firstElementChild.offsetWidth + 14 : 300);
      $('[data-nav=prev]', foot).onclick = ()=> rail.scrollBy({left:-step(), behavior:'smooth'});
      $('[data-nav=next]', foot).onclick = ()=> rail.scrollBy({left: step(), behavior:'smooth'});
    }

    /* puntos de posición, si el bloque los tiene */
    const dots = rail.parentElement.querySelector('[data-dots]');
    if (dots){
      const N = 4;
      for(let k=0;k<N;k++) dots.appendChild(document.createElement('i'));
      const marks = $$('i', dots);
      const paint = ()=>{
        const max = rail.scrollWidth - rail.clientWidth;
        const p = max>0 ? rail.scrollLeft/max : 0;
        const a = Math.min(N-1, Math.round(p*(N-1)));
        marks.forEach((m,k)=> m.classList.toggle('on', k===a));
      };
      marks[0].classList.add('on');
      rail.addEventListener('scroll', paint, {passive:true});
    }
  });

  /* --- 3.4 · carrito lateral ----------------------------------------------
     Acepta varios packs y cantidades, conserva la selección durante la sesión
     y mantiene un reloj propio de 15 minutos, independiente de la oferta. */
  const cartApi = (()=>{
    const shell = $('#cartShell');
    if (!shell) return { add(){} };
    const panel = $('#cartPanel');
    const backdrop = $('#cartBackdrop');
    const closeBtn = $('#cartClose');
    const itemsBox = $('#cartItems');
    const emptyBox = $('#cartEmpty');
    const emptyCta = $('#cartEmptyCta');
    const summary = $('#cartSummary');
    const footer = $('#cartFooter');
    const headerCount = $('#cartHeaderCount');
    const reserve = $('#cartReserve');
    const timer = $('#cartTimer');
    const badge = $('.cartc b');
    const cartLink = $('.cartc');
    const valueEl = $('#cartValue');
    const shippingEl = $('#cartShipping');
    const totalEl = $('#cartTotal');
    const savingEl = $('#cartSaving');
    const checkoutPrice = $('#cartCheckoutPrice');
    const checkout = $('#cartCheckout');
    const IMG = VIBA_ASSET('viba-iconos-bote.webp');
    const IMG2X = VIBA_ASSET('viba-iconos-bote@2x.webp');
    const KEY = 'viba:carrito';
    const TIMER_KEY = 'viba:carrito-hasta';
    const FIFTEEN = 15 * 60 * 1000;

    /* --- la tienda de verdad ----------------------------------------------
       En Shopify, la plantilla inyecta window.VIBA_SHOP con el id de variante
       y el precio real de cada pack. Lo escribe shopify/construir-tema.py en
       Liquid y busca **por SKU**, no por posición: si el producto se vuelve a
       crear los ids cambian, los SKU no.

       Si ese objeto no existe —el preview abierto como archivo— el carrito
       sigue siendo la maqueta de siempre: guarda en sessionStorage, no llama a
       nadie y no cobra. Así el mismo archivo vale para las dos cosas.        */
    const SHOP = (window.VIBA_SHOP && window.VIBA_SHOP.variants) ? window.VIBA_SHOP : null;
    const RUTAS = Object.assign({ add:'/cart/add.js', cart:'/cart.js',
                                  change:'/cart/change.js', checkout:'/checkout' },
                                SHOP && SHOP.routes);
    /* del id de variante al pack: hace falta para leer lo que Shopify ya
       tuviera guardado de una visita anterior */
    const PORVARIANTE = {};
    if (SHOP) Object.keys(SHOP.variants).forEach(k=>{
      if (SHOP.variants[k]) PORVARIANTE[String(SHOP.variants[k])] = k;
    });
    let lineas = {};                       /* pack → clave de línea del carrito */
    const errorBox = $('#cartError');
    const cartBody = $('.cart-body', panel);
    const avisar = msg => { if(!errorBox) return;
      errorBox.textContent = msg || ''; errorBox.hidden = !msg; };
    const cargandoBox = $('#cartCargando');
    let cargando = false;
    /* ⚠️ Quién se ve cuando el carrito está vacío, en un solo sitio.
       Mientras se añade NO se enseña «tu carrito está vacío»: el cajón se abre
       al instante para que el botón no parezca muerto, y enseñar el vacío medio
       segundo parece que la compra ha fallado.
       Tiene que llamarse también al SOLTAR el ocupado: al vaciar el carrito,
       `paint()` corre todavía en ocupado y el mensaje de vacío se quedaba
       escondido para siempre. Pasó y se cazó probándolo. */
    const pintarEstado = ()=>{
      const vacio = !lines().length;
      if (cargandoBox) cargandoBox.hidden = !(cargando && vacio);
      if (emptyBox) emptyBox.hidden = !vacio || cargando;
    };
    const ocupado = v => {
      cargando = v;
      if (cartBody) cartBody.setAttribute('aria-busy', v ? 'true' : 'false');
      pintarEstado();
    };
    const pedir = (url, body) => fetch(url, body
        ? { method:'POST', credentials:'same-origin',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify(body) }
        : { credentials:'same-origin', headers:{'Accept':'application/json'} })
      .then(r => r.json().then(d => r.ok ? d : Promise.reject(d)));
    const fallo = err => {
      console.error('[viba] carrito:', err);
      avisar((err && (err.description || err.message)) ||
             'No hemos podido actualizar el carrito. Inténtalo otra vez.');
    };

    const PACKS = {
      1:{ title:'1 mes', eyebrow:'Pack esencial', paid:1, free:0, bottles:1, caps:60, days:30,
          price:29.90, regular:29.90, value:29.90, daily:.99, ebook:false },
      3:{ title:'2 meses + 1 GRATIS', eyebrow:'El más vendido', paid:2, free:1, bottles:3, caps:180, days:90,
          price:59.80, regular:89.70, value:114.50, daily:.66, ebook:true },
      5:{ title:'3 meses + 2 GRATIS', eyebrow:'Mejor oferta', paid:3, free:2, bottles:5, caps:300, days:150,
          price:89.70, regular:149.50, value:174.30, daily:.60, ebook:true }
    };
    const money = n => n.toLocaleString('es-ES',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' €';
    /* Los precios están escritos en dos sitios: en el HTML de las tarjetas y
       aquí. Mientras eso siga así, **manda Shopify**, que es quien cobra: si
       no coincide, se reescribe lo que se ve y queda el aviso en la consola
       para corregir el preview. Nunca se enseña un precio y se cobra otro.  */
    if (SHOP && SHOP.prices) Object.keys(PACKS).forEach(k=>{
      const centimos = SHOP.prices[k];
      if (typeof centimos !== 'number' || centimos <= 0) return;
      const euros = centimos / 100;
      if (Math.abs(euros - PACKS[k].price) < 0.005) return;
      console.warn('[viba] el pack ' + k + ' pone ' + PACKS[k].price +
                   ' € y Shopify cobra ' + euros + ' €. Manda Shopify.');
      PACKS[k].price = euros;
      const tarjeta = document.querySelector('.bpack[data-u="' + k + '"]');
      if (!tarjeta) return;
      const ahora = tarjeta.querySelector('.bpack__now');
      if (ahora) ahora.textContent = money(euros);
      tarjeta.dataset.total = money(euros + (euros < 50 ? 4.90 : 0));
    });

    const load = ()=>{ try { return JSON.parse(sessionStorage.getItem(KEY) || '{}') || {} } catch(e){ return {} } };
    /* con Shopify el carrito lo guarda Shopify: aquí no se duplica */
    const save = ()=>{ if (SHOP) return;
      try { sessionStorage.setItem(KEY, JSON.stringify(state)) } catch(e){} };
    /* lo que devuelve /cart.js, traducido a packs */
    const desdeCarrito = cart => {
      state = {}; lineas = {};
      (cart && cart.items || []).forEach(it=>{
        const k = PORVARIANTE[String(it.id)] || PORVARIANTE[String(it.variant_id)];
        if (!k) return;
        state[k] = (state[k] || 0) + it.quantity;
        lineas[k] = it.key;
      });
    };
    let state = SHOP ? {} : load();
    let lastFocus = null;
    let hideTimer = 0;
    let clock = 0;
    const lines = ()=> Object.keys(state).filter(k=>PACKS[k] && state[k] > 0);
    const count = ()=> lines().reduce((n,k)=>n + state[k],0);
    const productTotal = ()=> lines().reduce((n,k)=>n + PACKS[k].price * state[k],0);
    const shipping = ()=> productTotal() > 0 && productTotal() < 50 ? 4.90 : 0;
    const grandTotal = ()=> productTotal() + shipping();
    const fullValue = ()=> lines().reduce((n,k)=>n + PACKS[k].value * state[k],0) + (shipping() ? 4.90 : 0);
    const savings = ()=> Math.max(0, fullValue() - grandTotal());

    const group = (n,kind='') => '<span class="cart-item__group'+(kind?' cart-item__group--'+kind:'')+'">' +
      Array.from({length:n},()=>'<img class="cart-item__bote" src="'+IMG+'" ' +
        'srcset="'+IMG+' 110w, '+IMG2X+' 220w" sizes="34px" alt="">').join('') + '</span>';
    /* Cómo se dibujan los botes de una línea del carrito.

       ⚠️ Antes se amontonaban: con dos packs de 3 salían SEIS botes de 34 px en
       una caja de 94, se salían por los lados y la etiqueta «×6» caía encima del
       texto. Ahora hay dos formas y ninguna se sale:

       · LA OFERTA (una unidad de un pack con regalo): los que pagas, el «+» y
         los de regalo. Es lo que explica el 2+1 y el 3+2, así que aquí el «+»
         se queda.
       · TODO LO DEMÁS: no hay nada que explicar con un «+», así que se dibujan
         como mucho cuatro botes y **el total va arriba en una etiqueta**
         (×2, ×6, ×10…). Nunca se dibujan más de cuatro: a partir de ahí el
         montón no dice nada que no diga el número.

       El tamaño del bote lo elige el CSS con `data-n`, así que cuantos más hay,
       más pequeños se dibujan y el conjunto SIEMPRE cabe en los 94 px.        */
    const visual = (p,qty) => {
      const total = p.bottles * qty;
      const conRegalo = qty === 1 && p.free > 0;
      if (conRegalo){
        return '<span class="cart-item__botes" data-n="'+total+'">' +
          group(p.paid,'paid') + '<span class="cart-item__plus">+</span>' +
          group(p.free,'gift') + '</span>';
      }
      const dibujados = Math.min(total, 4);
      return (total > 1 ? '<span class="cart-item__count">&times;'+total+'</span>' : '') +
        '<span class="cart-item__botes" data-n="'+dibujados+'">' +
        group(dibujados,'all') + '</span>';
    };
    const check = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10.5l4 4 8-9"/></svg>';
    const detail = (label,value) => '<div class="cart-item__detail"><span>'+check+label+'</span><b>'+value+'</b></div>';
    const card = (key, freeShipping) => {
      const p = PACKS[key];
      const qty = state[key];
      const old = p.regular > p.price ? '<s>'+money(p.regular * qty)+'</s>' : '<s aria-hidden="true">&nbsp;</s>';
      const shippingLine = freeShipping
        ? '<s>4,90 €</s><span class="cart-item__free">GRATIS</span>'
        : '4,90 €';
      const packLine = '<span class="cart-item__deal"><strong>'+money(p.price * qty)+'</strong>' +
        (p.regular > p.price ? '<s>'+money(p.regular * qty)+'</s>' : '') + '</span>';
      return '<article class="cart-item" data-pack="'+key+'">' +
        '<div class="cart-item__main"><div class="cart-item__visual" aria-hidden="true">'+visual(p,qty)+'</div>' +
        '<div class="cart-item__copy"><span class="cart-item__eyebrow">'+p.eyebrow+'</span>' +
        '<strong class="cart-item__title">'+p.title+'</strong>' +
        '<span class="cart-item__meta">'+p.bottles+' '+(p.bottles===1?'bote':'botes')+' · '+p.caps+' cápsulas · '+p.days+' días</span>' +
        '<span class="cart-item__daily"><b>'+money(p.daily)+'</b> al día</span></div>' +
        '<div class="cart-item__price">'+old+'<strong>'+money(p.price * qty)+'</strong></div></div>' +
        '<div class="cart-item__details">' +
          '<span class="cart-item__details-title">Lo que te llevas</span>' +
          detail((p.bottles * qty)+' bote'+(p.bottles * qty===1?'':'s')+' de viba Intelecto Forte',packLine) +
          detail('Envío en 24-48 h',shippingLine) +
          (p.ebook ? detail('E-book «Cuida tu memoria»','<s>19,90 €</s><span class="cart-item__free">GRATIS</span>') : '') +
          detail('Devuelves lo que no abras','90 días') +
        '</div>' +
        '<div class="cart-item__foot"><div class="cart-qty" aria-label="Cantidad">' +
          '<button type="button" data-action="dec" aria-label="Restar una unidad">−</button>' +
          '<output aria-live="polite">'+qty+'</output>' +
          '<button type="button" data-action="inc" aria-label="Añadir una unidad">+</button></div>' +
          '<button type="button" class="cart-remove" data-action="remove">Eliminar</button></div></article>';
    };

    const paintBadge = ()=>{
      const n = count();
      if (badge){ badge.textContent = String(n); badge.hidden = n === 0; }
      if (headerCount) headerCount.textContent = String(n);
    };
    const paint = ()=>{
      const keys = lines();
      const freeShipping = productTotal() >= 50;
      itemsBox.innerHTML = keys.map(k=>card(k,freeShipping)).join('');
      pintarEstado();
      summary.hidden = keys.length === 0;
      footer.hidden = keys.length === 0;
      if (keys.length){
        valueEl.textContent = money(fullValue());
        shippingEl.textContent = shipping() ? money(shipping()) : 'GRATIS';
        totalEl.textContent = money(grandTotal());
        savingEl.textContent = money(savings());
        checkoutPrice.textContent = money(grandTotal());
      }
      paintBadge();
      save();
    };

    const timerEnd = ()=>{ try { return +sessionStorage.getItem(TIMER_KEY) || 0 } catch(e){ return 0 } };
    const setTimerEnd = v=>{ try { sessionStorage.setItem(TIMER_KEY,String(v)) } catch(e){} };
    const startClock = reset=>{
      let end = timerEnd();
      if (reset || !end || end <= Date.now()){ end = Date.now() + FIFTEEN; setTimerEnd(end); }
      reserve.querySelector('span').childNodes[0].nodeValue='Te guardamos el carrito ';
      reserve.classList.remove('is-expired');
      clearInterval(clock);
      const tick = ()=>{
        const left = Math.max(0,Math.ceil((end-Date.now())/1000));
        timer.textContent = String(Math.floor(left/60)).padStart(2,'0')+':'+String(left%60).padStart(2,'0');
        reserve.classList.toggle('is-expired',left===0);
        if (left===0){ reserve.querySelector('span').childNodes[0].nodeValue='Tu reserva ha terminado '; clearInterval(clock); }
      };
      tick(); clock=setInterval(tick,1000);
    };
    const pararReloj = ()=>{
      try { sessionStorage.removeItem(TIMER_KEY) } catch(e){}
      clearInterval(clock); timer.textContent='15:00';
    };
    const open = ()=>{
      clearTimeout(hideTimer); lastFocus=document.activeElement; shell.hidden=false;
      document.body.classList.add('cart-lock');
      requestAnimationFrame(()=>{ shell.classList.add('is-open'); panel.focus({preventScroll:true}); });
    };
    const close = ()=>{
      shell.classList.remove('is-open'); document.body.classList.remove('cart-lock');
      hideTimer=setTimeout(()=>{ shell.hidden=true; if(lastFocus?.focus) lastFocus.focus({preventScroll:true}); },380);
    };
    const avisarAnalitica = key => document.dispatchEvent(new CustomEvent('viba:add-to-cart',
      {detail:{pack:Number(key), quantity:state[key], total:grandTotal()}}));
    const add = key=>{
      key=String(key); if(!PACKS[key]) return;
      if (!SHOP){                                   /* preview: maqueta */
        state[key]=(state[key]||0)+1;
        startClock(count()===1); paint(); open();
        avisarAnalitica(key);
        return;
      }
      const variante = SHOP.variants[key];
      if (!variante){
        console.error('[viba] el pack ' + key + ' no tiene variante en Shopify');
        open(); avisar('Ese pack no está disponible ahora mismo.');
        return;
      }
      /* el cajón se abre ya, aunque la respuesta tarde: si se esperase, el
         botón parecería muerto medio segundo */
      avisar(''); ocupado(true); open();
      pedir(RUTAS.add, { items:[{ id: variante, quantity: 1 }] })
        .then(()=> pedir(RUTAS.cart))
        .then(cart=>{
          desdeCarrito(cart);
          startClock(count()===1); paint();
          avisarAnalitica(key);
        })
        .catch(fallo)
        .finally(()=> ocupado(false));
    };
    itemsBox.addEventListener('click',ev=>{
      const button=ev.target.closest('button[data-action]'); if(!button) return;
      const item=button.closest('[data-pack]'); const key=item?.dataset.pack; if(!key) return;
      const antes = state[key] || 0;
      const ahora = button.dataset.action==='inc' ? antes + 1
                  : button.dataset.action==='dec' ? Math.max(0, antes - 1)
                  : 0;
      if (ahora === antes) return;
      if (!SHOP){                                   /* preview: maqueta */
        state[key] = ahora;
        if(!count()) pararReloj();
        paint();
        return;
      }
      /* Shopify acepta la clave de línea; si por lo que sea no la tenemos,
         el id de variante también le vale cuando la línea no lleva extras */
      avisar(''); ocupado(true);
      pedir(RUTAS.change, { id: lineas[key] || String(SHOP.variants[key]), quantity: ahora })
        .then(cart=>{ desdeCarrito(cart); if(!count()) pararReloj(); paint(); })
        .catch(fallo)
        .finally(()=> ocupado(false));
    });
    if (cartLink) cartLink.addEventListener('click',ev=>{ ev.preventDefault(); open(); });
    closeBtn.addEventListener('click',close); backdrop.addEventListener('click',close);
    if (emptyCta) emptyCta.addEventListener('click',close);
    shell.addEventListener('keydown',ev=>{
      if(ev.key==='Escape'){ close(); return; }
      if(ev.key!=='Tab') return;
      const focusable=$$('button:not([disabled]),a[href],input:not([disabled])',panel);
      if(!focusable.length) return;
      const first=focusable[0],last=focusable[focusable.length-1];
      if(ev.shiftKey&&document.activeElement===first){ev.preventDefault();last.focus();}
      else if(!ev.shiftKey&&document.activeElement===last){ev.preventDefault();first.focus();}
    });
    checkout.addEventListener('click',()=>{
      document.dispatchEvent(new CustomEvent('viba:checkout',{detail:{items:{...state},total:grandTotal()}}));
      if (SHOP && count()) window.location.href = RUTAS.checkout;
    });
    paint();
    if (SHOP){
      /* Shopify puede traer ya un carrito de una visita anterior */
      pedir(RUTAS.cart)
        .then(cart=>{ desdeCarrito(cart); paint(); if(count()) startClock(false); })
        .catch(err=> console.error('[viba] no se pudo leer el carrito:', err));
    } else if (count()) startClock(false);
    else timer.textContent='15:00';
    return {add,open,close};
  })();

  /* --- 3.5 · selector de packs -------------------------------------------
     Una sola función: marca la tarjeta elegida, escribe el precio en los dos
     botones y enciende o apaga los regalos según cuántos botes lleve.      */
  const bundle = $('#bundle');
  if (bundle){
    const packs  = $$('.bpack', bundle);
    const precio = $('#ctaPrecio');

    const elegir = pack => {
      /* la clase .on hace tres cosas a la vez: rellena la tarjeta, abre su
         desplegable y cierra el de las otras dos. Todo lo demás es CSS.    */
      packs.forEach(p => p.classList.toggle('on', p === pack));
      $('input', pack).checked = true;

      /* data-total es lo que se cobra de verdad: el de 1 mes lleva el envío */
      const total = pack.dataset.total;
      if (precio) precio.textContent = total;
    };

    packs.forEach(p => p.addEventListener('click', () => elegir(p)));
    elegir($('.bpack.on', bundle) || packs[0]);

    /* La barra fija anuncia siempre la oferta 2+1. Al pulsarla selecciona ese
       pack y dispara el mismo CTA principal de compra, sin volver al selector. */
    const stickyCta = $('#stickyCta');
    const packOferta = $('.bpack[data-u="3"]', bundle);
    const compraPrincipal = $('#cta');
    const confirmar = (pack, boton)=>{
      cartApi.add(Number(pack.dataset.u));
      const texto = boton && (boton.querySelector('.cta__t') || boton.querySelector('span:last-child'));
      if (texto){
        /* ⚠️ innerHTML y no textContent: el rótulo de la barra fija lleva dentro
           un <i> que se esconde en móvil («AÑADIR» a secas). Con textContent ese
           <i> desaparecía al primer clic y el botón se quedaba largo para
           siempre. */
        const original = texto.innerHTML;
        texto.textContent = 'AÑADIDO ✓';
        clearTimeout(boton._restauraTexto);
        boton._restauraTexto = setTimeout(()=>{ texto.innerHTML = original; }, 1300);
      }
    };
    if (compraPrincipal) compraPrincipal.addEventListener('click', ev=>{
      ev.preventDefault();
      confirmar($('.bpack.on', bundle) || packs[0], compraPrincipal);
    });
    if (stickyCta && packOferta) stickyCta.addEventListener('click', ()=>{
      elegir(packOferta);
      confirmar(packOferta, stickyCta);
    });
  }

  /* --- 5 · carrusel de cubierta de las reseñas -----------------------------
     Centra la tarjeta activa moviendo el carril. El ancho se mide en vivo
     porque las tarjetas escalan con transform y el layout no cambia.        */
  const cf = $('[data-cf]');
  if (cf){
    const track = $('.cf__track', cf);
    const items = $$('.cf__item', cf);
    const dots  = $('[data-cf-dots]');
    let activa = Math.floor(items.length / 2);

    if (dots){
      items.forEach((_, k)=>{
        const i = document.createElement('i');
        i.onclick = ()=> ir(k);
        dots.appendChild(i);
      });
    }

    function pintar(){
      items.forEach((el, k)=>{
        const d = Math.abs(k - activa);
        el.classList.toggle('on', d === 0);
        el.classList.toggle('cerca', d === 1);
        el.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
      });
      if (dots) $$('i', dots).forEach((d, k)=> d.classList.toggle('on', k === activa));
      const el = items[activa];
      const centroTarjeta = el.offsetLeft + el.offsetWidth / 2;
      track.style.transform = 'translateX(' + (cf.clientWidth / 2 - centroTarjeta) + 'px)';
    }
    function ir(k){ activa = Math.max(0, Math.min(items.length - 1, k)); pintar(); }

    items.forEach((el, k)=> el.addEventListener('click', ()=>{ if (k !== activa) ir(k); }));
    $('.cf__nav--prev', cf).onclick = ()=> ir(activa - 1);
    $('.cf__nav--next', cf).onclick = ()=> ir(activa + 1);

    /* arrastrar con el dedo o con el ratón */
    let x0 = null;
    const inicio = e => { x0 = (e.touches ? e.touches[0] : e).clientX; };
    const fin = e => {
      if (x0 === null) return;
      const dx = (e.changedTouches ? e.changedTouches[0] : e).clientX - x0;
      if (Math.abs(dx) > 40) ir(activa + (dx < 0 ? 1 : -1));
      x0 = null;
    };
    cf.addEventListener('touchstart', inicio, {passive:true});
    cf.addEventListener('touchend', fin, {passive:true});
    cf.addEventListener('mousedown', inicio);
    cf.addEventListener('mouseup', fin);

    addEventListener('resize', pintar, {passive:true});
    if (document.fonts) document.fonts.ready.then(pintar);
    pintar();
  }

  /* --- 5.5 · los anillos de porcentaje --------------------------------------
     Suben de 0 al valor cuando la sección entra en pantalla, una sola vez.
     El número y la máscara del anillo van del mismo contador.               */
  $$('.ncard').forEach(card=>{
    const destino = parseFloat(card.dataset.num) || 0;
    const marcador = $('.ncard__v', card);
    let hecho = false;

    const animar = ()=>{
      const t0 = performance.now(), dur = 1400;
      const paso = ahora=>{
        const t = Math.min(1, (ahora - t0) / dur);
        const suave = 1 - Math.pow(1 - t, 3);          /* frena al final */
        const v = destino * suave;
        card.style.setProperty('--p', v.toFixed(2));
        marcador.textContent = Math.round(v) + '%';
        if (t < 1) requestAnimationFrame(paso);
      };
      requestAnimationFrame(paso);
    };

    const obs = new IntersectionObserver(es=>{
      es.forEach(e=>{ if (e.isIntersecting && !hecho){ hecho = true; animar(); obs.disconnect(); } });
    }, {threshold:.35});
    obs.observe(card);

    /* el resplandor sigue al cursor */
    card.addEventListener('mousemove', e=>{
      const r = card.getBoundingClientRect();
      card.style.setProperty('--mouse-x', (e.clientX - r.left) + 'px');
      card.style.setProperty('--mouse-y', (e.clientY - r.top) + 'px');
    });
  });

  /* --- 5.55 · tarjetas de ingredientes --------------------------------------
     Cada «Ver más» despliega únicamente el contenido de su propia tarjeta.   */
  (()=>{
    const rail = $('[data-ing-rail]');
    if (!rail) return;
    $$('.ing', rail).forEach(card=>{
      const mas = $('.ing__mas', card);
      const alternar = e=>{
        e?.stopPropagation();
        const abierto = card.getAttribute('aria-expanded') === 'true';
        card.setAttribute('aria-expanded', String(!abierto));
        mas.textContent = abierto ? 'Ver más' : 'Ver menos';
      };
      mas.addEventListener('click', alternar);
    });
  })();

  /* --- 6 · acordeones: solo uno abierto por grupo ------------------------- */
  $$('details.acc').forEach(d=>{
    d.addEventListener('toggle', ()=>{
      if(!d.open) return;
      $$('details.acc', d.parentElement).forEach(o=>{ if(o!==d) o.open=false; });
    });
  });

  /* --- 7 · aparición al hacer scroll -------------------------------------- */
  const io = new IntersectionObserver(es=>{
    es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {rootMargin:'0px 0px -8% 0px', threshold:.06});
  $$('.rise').forEach(el=> io.observe(el));

  /* --- 8 · oferta fija: aparece al superar el primer CTA y permanece visible
     durante todo el resto de la página, incluido el pie. ------------------- */
  const bar = $('#stickybar');
  const heroBtn = $('#cta');
  if (bar && heroBtn){
    let ctaSuperado = false;
    const pintarBarra = ()=>{
      const mostrar = ctaSuperado;
      bar.classList.toggle('on', mostrar);
      bar.setAttribute('aria-hidden', String(!mostrar));
      bar.inert = !mostrar;
    };
    let frameBarra = 0;
    const medirBarra = ()=>{
      if (frameBarra) return;
      frameBarra = requestAnimationFrame(()=>{
        frameBarra = 0;
        ctaSuperado = heroBtn.getBoundingClientRect().bottom < 0;
        pintarBarra();
      });
    };
    addEventListener('scroll', medirBarra, {passive:true});
    addEventListener('resize', medirBarra, {passive:true});
    medirBarra();
  }

  /* 9.5 · aquí se encendía .fade-top al bajar. Quitado el 22/09 con la franja. */

  /* --- 9.6 · carrusel de móvil ---------------------------------------------
     Las flechas y el contador «2/5» se crean desde aquí y no en el HTML: en
     ordenador no existen, porque allí la sección es una rejilla y no hay nada
     que pasar. Así el HTML no carga con botones muertos.

     El desplazamiento se mide en vivo (`getBoundingClientRect`) y no con un
     número fijo, porque el ancho de la tarjeta es un porcentaje y cambia al
     girar el teléfono.                                                       */
  (()=>{
    const carriles = $$('[data-carru]');
    if (!carriles.length) return;
    const movil = matchMedia('(max-width:760px)');
    const flecha = d => '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" ' +
      'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M' + (d < 0 ? '12.5 4L6.5 10l6 6' : '7.5 4l6 6-6 6') + '"/></svg>';

    carriles.forEach(carril=>{
      const total = carril.children.length;
      if (total < 2) return;

      /* Dos indicadores según lo que pida la sección:
         - por defecto, flechas y contador «3 / 5» (ingredientes, reseñas)
         - data-carru="puntos", solo puntos (línea del tiempo y beneficios):
           son tiras cortas y las flechas sobran                              */
      const conPuntos = carril.dataset.carru === 'puntos';
      const nav = document.createElement('div');
      nav.className = 'carru-nav' + (conPuntos ? ' carru-nav--puntos' : '');
      nav.innerHTML = conPuntos
        ? Array.from({length:total},(_,i)=>
            '<button type="button" class="carru-p" data-a="' + i + '" ' +
            'aria-label="Ir al ' + (i+1) + ' de ' + total + '"></button>').join('')
        : '<button type="button" class="carru-b" data-ir="-1" aria-label="Anterior">' + flecha(-1) + '</button>' +
          '<span class="carru-pos" aria-live="polite"><b>1</b>&thinsp;/&thinsp;<i>' + total + '</i></span>' +
          '<button type="button" class="carru-b" data-ir="1" aria-label="Siguiente">' + flecha(1) + '</button>';
      carril.after(nav);

      const posEl = $('b', nav);
      const botones = $$('.carru-b', nav);
      const puntos = $$('.carru-p', nav);
      const paso = ()=>{
        const a = carril.children[0], b = carril.children[1];
        return b ? b.getBoundingClientRect().left - a.getBoundingClientRect().left
                 : a.getBoundingClientRect().width;
      };
      const indice = ()=> Math.round(carril.scrollLeft / (paso() || 1));

      const pintar = ()=>{
        const i = Math.max(0, Math.min(total - 1, indice()));
        if (conPuntos){
          puntos.forEach((p, k)=> p.classList.toggle('on', k === i));
        } else {
          posEl.textContent = String(i + 1);
          botones[0].disabled = i === 0;
          botones[1].disabled = i === total - 1;
        }
      };

      const quieto = ()=> matchMedia('(prefers-reduced-motion:reduce)').matches;
      nav.addEventListener('click', ev=>{
        const p = ev.target.closest('.carru-p');
        if (p){
          carril.scrollTo({ left: paso() * Number(p.dataset.a), behavior: quieto() ? 'auto' : 'smooth' });
          return;
        }
        const b = ev.target.closest('.carru-b'); if (!b) return;
        carril.scrollBy({ left: paso() * Number(b.dataset.ir), behavior: quieto() ? 'auto' : 'smooth' });
      });

      let marco = 0;
      carril.addEventListener('scroll', ()=>{
        if (marco) return;
        marco = requestAnimationFrame(()=>{ marco = 0; pintar(); });
      }, {passive:true});
      addEventListener('resize', pintar, {passive:true});
      /* al pasar de móvil a ordenador la rejilla vuelve y el scroll se queda
         a medias: se devuelve al principio para que no falte la primera */
      movil.addEventListener('change', e=>{ if (!e.matches) carril.scrollLeft = 0; else pintar(); });
      pintar();
    });
  })();

  /* --- 10 · dudas de la columna de compra ----------------------------------
     La respuesta va con max-height porque height:auto no se puede animar. El
     JS le mide la altura real al abrirla; si cambia el ancho, se vuelve a medir
     la que esté abierta para que no se quede cortada.                        */
  const gruposFaq = $$('.faqp');
  if (gruposFaq.length){
    const cerrar = btn=>{
      btn.parentElement.classList.remove('on');
      btn.setAttribute('aria-expanded', 'false');
      btn.nextElementSibling.style.maxHeight = '0px';
    };
    const abrir = btn=>{
      btn.parentElement.classList.add('on');
      btn.setAttribute('aria-expanded', 'true');
      btn.nextElementSibling.style.maxHeight = btn.nextElementSibling.scrollHeight + 'px';
    };

    gruposFaq.forEach(grupo=>{
      const botones = $$('.faqp__q', grupo);
      botones.forEach(btn=>{
        btn.addEventListener('click', ()=>{
          const abierta = btn.getAttribute('aria-expanded') === 'true';
          botones.forEach(cerrar);           // una abierta por cada bloque
          if (!abierta) abrir(btn);
        });
      });

      /* Antes se abría sola la primera pregunta, copiando la referencia.
         Joan lo quitó el 22/09: arrancan todas cerradas. */
    });

    addEventListener('resize', ()=>{
      $$('.faqp__q[aria-expanded="true"]').forEach(btn=>{
        btn.nextElementSibling.style.maxHeight = btn.nextElementSibling.scrollHeight + 'px';
      });
    });
  }

  /* --- 10.5 · reseñas adicionales -----------------------------------------
     Mantiene el listado breve de entrada y abre las siguientes filas con una
     transición progresiva, sin saltos bruscos de altura.                    */
  const reviewsMore = $('#reviewsMore');
  const reviewsMoreToggle = $('#reviewsMoreToggle');
  if (reviewsMore && reviewsMoreToggle){
    reviewsMoreToggle.addEventListener('click', ()=>{
      const abierto = reviewsMore.classList.toggle('on');
      reviewsMoreToggle.setAttribute('aria-expanded', String(abierto));
      reviewsMoreToggle.firstChild.nodeValue = abierto ? 'Ver menos reseñas ' : 'Ver más reseñas ';
    });
  }

  /* --- 9 · ventana de descuento · APAGADA ----------------------------------
     Está montada y probada, pero NO sale. Decisión de Joan el 17/09.

       POP_ACTIVO   false = no salta nunca sola. Ponerlo en true para encenderla.
       POP_SEGUNDOS a los cuántos segundos aparece, una vez encendida.
       POP_UNA_VEZ  true = cada visitante la ve una sola vez. Al publicar, true.

     Estando apagada, se puede ver a mano abriendo la página con  ?popup=1
     al final de la dirección. Así no la ve nadie sin querer.                 */
  const POP_ACTIVO   = false;
  const POP_SEGUNDOS = 8;
  const POP_UNA_VEZ  = false;
  const POP_LLAVE    = 'viba_pop_visto';

  const popShell = $('#popShell');
  if (popShell){
    const popCard  = $('#popCard');
    const popForm  = $('#popForm');
    const popEmail = $('#popEmail');
    const popOk    = $('#popOk');
    const forzada  = /[?&#]popup=1/.test(location.search + location.hash);
    let popTimer, popOcultar, popFoco;

    const yaVista = ()=>{
      if (forzada || !POP_UNA_VEZ) return false;
      try { return localStorage.getItem(POP_LLAVE) === '1'; } catch(e){ return false; }
    };
    const marcarVista = ()=>{
      if (!POP_UNA_VEZ) return;
      try { localStorage.setItem(POP_LLAVE, '1'); } catch(e){}
    };

    const abrirPop = ()=>{
      if (!popShell.hidden) return;
      const comp = $('#compShell');
      if (comp && !comp.hidden) return;          // no se pisa con la composición
      clearTimeout(popOcultar);
      popFoco = document.activeElement;
      popShell.hidden = false;
      document.body.classList.add('comp-lock');
      requestAnimationFrame(()=>{
        popShell.classList.add('is-open');
        popCard.focus({preventScroll:true});
      });
      marcarVista();
    };

    const cerrarPop = ()=>{
      popShell.classList.remove('is-open');
      document.body.classList.remove('comp-lock');
      clearTimeout(popOcultar);
      popOcultar = setTimeout(()=>{
        if (!popShell.classList.contains('is-open')) popShell.hidden = true;
      }, matchMedia('(prefers-reduced-motion:reduce)').matches ? 0 : 320);
      if (popFoco && popFoco.focus) popFoco.focus({preventScroll:true});
    };

    if ((POP_ACTIVO || forzada) && !yaVista())
      popTimer = setTimeout(abrirPop, (forzada ? 1 : POP_SEGUNDOS) * 1000);

    $('#popCerrar').addEventListener('click', cerrarPop);
    $('#popNo').addEventListener('click', cerrarPop);
    $('#popBackdrop').addEventListener('click', cerrarPop);
    $('#popSeguir').addEventListener('click', cerrarPop);

    popForm.addEventListener('submit', e=>{
      e.preventDefault();
      const correo = popEmail.value.trim();
      const vale = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(correo);
      popEmail.classList.toggle('mal', !vale);
      if (!vale){ popEmail.focus(); return; }
      if (!popOk.checked){ popOk.focus(); return; }
      /* Aquí irá el envío a Klaviyo cuando la tienda esté en Shopify.
         De momento no sale de la página: solo enseña el código.             */
      $('#popOferta').hidden = true;
      $('#popGracias').hidden = false;
      popCard.focus({preventScroll:true});
    });

    document.addEventListener('keydown', e=>{
      if (popShell.hidden) return;
      if (e.key === 'Escape'){ e.preventDefault(); cerrarPop(); return; }
      if (e.key !== 'Tab') return;
      const focos = popCard.querySelectorAll('button:not([hidden]),input,a[href]');
      const vivos = [...focos].filter(el=>el.offsetParent !== null);
      if (!vivos.length) return;
      const primero = vivos[0], ultimo = vivos[vivos.length-1];
      if (e.shiftKey && document.activeElement === primero){ e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo){ e.preventDefault(); primero.focus(); }
    });
  }
})();
